module.exports = __webpack_public_path__ + "static/media/Aerobics.53d9670e.png";